import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { Container } from 'react-bootstrap';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { LegalDocument } from '../../components/Legalese/LegalDocument';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';
import styles from './Legal.module.scss';

type LegalTab = 'privacy' | 'cookie' | 'tos';

const LegalComponent = () => {
  const history = useHistory();
  const { doc } = useParams<{ doc: LegalTab }>();
  const activeTab: LegalTab = doc || 'privacy';

  const { t } = useTranslation();
  const tabs: [LegalTab, string][] = [
    ['privacy', t('legalese.labels.privacy')],
    ['cookie', t('legalese.labels.cookie')],
    ['tos', t('legalese.labels.tos')],
  ];

  useEffect(() => {
    if (!doc) history.replace('/legal/privacy');
  }, [doc, history]);

  return (
    <AppShell>
      <div className={styles.page}>
        <Title>{t('legalese.labels.legal')}</Title>

        <Container fluid className={styles.content}>
          <section className="tabbed-workspace" aria-label={t('legalese.labels.documentiLegali')}>
            <div className="tabbed-workspace-tabs" role="tablist" aria-label={t('legalese.labels.documentiLegali')}>
              {tabs.map(([tab, label]) => (
                <Link
                  key={tab}
                  role="tab"
                  id={`legal-tab-${tab}`}
                  aria-selected={activeTab === tab}
                  aria-controls={`legal-panel-${tab}`}
                  to={`/legal/${tab}`}
                  className={activeTab === tab ? 'tabbed-workspace-active' : undefined}
                >
                  {label}
                </Link>
              ))}
            </div>
            <div id={`legal-panel-${activeTab}`} role="tabpanel" aria-labelledby={`legal-tab-${activeTab}`} className="tabbed-workspace-panel">
              <LegalDocument doc={activeTab} />
            </div>
          </section>
        </Container>

        <Footer />
      </div>
    </AppShell>
  );
};

export default LegalComponent;
